import {
    APPLY_FILTER,
    APPLY_SORT,
    CLEAR_FILTER,
    CLEAR_FILTERS,
    CLEAR_SORT,
    GET_CATEGORY_PRODUCTS,
    GET_CATEGORY_PRODUCTS_ERROR,
    GET_CATEGORY_PRODUCTS_SUCCESS,
    GET_PRODUCTS,
    GET_PRODUCTS_ERROR,
    GET_PRODUCTS_SUCCESS,
    REMOVE_FILTER,
    RESOLVE_PAGE_DEPENDENCIES,
    RESOLVE_PAGE_DEPENDENCIES_ERROR,
    RESOLVE_PAGE_DEPENDENCIES_SUCCESS,
    SAVE_AUTOMATED_DISCOUNT,
    SEARCH_PRODUCTS,
    SEARCH_PRODUCTS_ERROR,
    SEARCH_PRODUCTS_SUCCESS,
    SET_ALL_PRODUCTS,
    SET_ALL_PRODUCTS_ERROR,
    SET_ALL_PRODUCTS_SUCCESS,
    SET_CATEGORY_TREE_SUCCESS,
} from "./constants";

import produce from "immer";

// The initial state of this store.
const initialState = {
    products: [],
    allProducts: [],
    pagination: {
        page: 0,
        pageSize: 12,
        pageCount: null,
        hitsCount: 0,
    },
    isFetching: false,
    appliedFilters: {},
    appliedSort: null,
    algolia: {},
    categoryTree: [],
    automatedDiscounts: {},
};

export default produce((state, action) => {
    switch (action.type) {
        case GET_PRODUCTS: {
            state.isFetching = true;
            break;
        }
        case GET_PRODUCTS_SUCCESS: {
            state.products = action.products;
            state.isFetching = false;
            break;
        }
        case GET_PRODUCTS_ERROR: {
            break;
        }
        case SET_ALL_PRODUCTS: {
            break;
        }
        case SET_ALL_PRODUCTS_SUCCESS: {
            state.allProducts = action.products;
            break;
        }
        case SET_ALL_PRODUCTS_ERROR: {
            break;
        }
        case GET_CATEGORY_PRODUCTS: {
            state.isFetching = true;
            break;
        }
        case GET_CATEGORY_PRODUCTS_SUCCESS: {
            state.products = action.products;
            state.isFetching = false;
            break;
        }
        case GET_CATEGORY_PRODUCTS_ERROR: {
            state.isFetching = false;
            break;
        }
        case SEARCH_PRODUCTS: {
            state.isFetching = true;
            break;
        }
        case SEARCH_PRODUCTS_SUCCESS: {
            state.products = action.products;
            state.isFetching = false;
            state.pagination = action.pagination;
            break;
        }
        case SEARCH_PRODUCTS_ERROR: {
            state.isFetching = false;
            break;
        }
        case APPLY_FILTER: {
            const { filter, value } = action;
            if (state.appliedFilters[filter] === undefined) {
                state.appliedFilters[filter] = [];
                state.appliedFilters[filter].push(value);
            } else {
                if (state.appliedFilters[filter].indexOf(value) === -1) {
                    state.appliedFilters[filter].push(value);
                }
            }
            break;
        }
        case REMOVE_FILTER: {
            const { filter, value } = action;
            const appliedFilters = state.appliedFilters;
            const newAppliedFilters = {};

            if (appliedFilters[filter] && appliedFilters[filter].length > 0) {
                const index = appliedFilters[filter].indexOf(value);
                if (index !== -1) {
                    appliedFilters[filter].splice(index, 1);
                }
            }

            // if the filter is empty, lets remove it
            // so we don't just return an empty array on the appliedFilter[key]
            for (const key in appliedFilters) {
                if (appliedFilters[key].length > 0) {
                    newAppliedFilters[key] = appliedFilters[key];
                }
            }

            state.appliedFilters = newAppliedFilters;
            break;
        }
        case CLEAR_FILTER: {
            break;
        }
        case CLEAR_FILTERS: {
            for (const key in state.appliedFilters) {
                if (key === "categoryId") {
                    continue;
                } else {
                    state.appliedFilters[key] = [];
                }
            }
            break;
        }
        case APPLY_SORT: {
            state.appliedSort = action.sort;
            break;
        }
        case CLEAR_SORT: {
            state.appliedSort = null;
            break;
        }
        case RESOLVE_PAGE_DEPENDENCIES: {
            break;
        }
        case RESOLVE_PAGE_DEPENDENCIES_SUCCESS: {
            state.algolia = { ...state.algolia, ...action.data };
            state.categoryTree = action.categoryTree || [];
            break;
        }

        case RESOLVE_PAGE_DEPENDENCIES_ERROR: {
            break;
        }

        case SET_CATEGORY_TREE_SUCCESS: {
            state.categoryTree = action.categoryTree || [];
            break;
        }

        case SAVE_AUTOMATED_DISCOUNT: {
            state.automatedDiscounts = {
                ...state.automatedDiscounts,
                [action.partNo]: action.automatedDiscountData,
            };

            break;
        }

        // Default.
        default:
            return state;
    }
}, initialState);
